import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedComics() {
  const featured = comics.filter((c) => c.isHot).slice(0, 6);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">本周最受欢迎的耽美韩漫</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap transition-colors"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
        {featured.map((comic) => (
          <ComicCard key={comic.id} {...comic} />
        ))}
      </div>
    </section>
  );
}